import {Route} from "./Route";
import {RouteDescriptor} from "./RouteDescriptor";
import {home} from "./all/common/home";
import {forBrokers} from "./all/common/forBrokers";
import {forOperators} from "./all/common/forOperators";
import {price} from "./all/common/price";
import {agents} from "./all/common/agents";
import {airportData} from "./all/common/airportData";
import {login} from "./all/auth/login";
import {register} from "./all/auth/register";
import {setNewPassword} from "./all/auth/setNewPassword";
import {profile} from "./lk/lkCommon/profile";
import {settings} from "./lk/lkCommon/settings";
import {messageTemplates} from "./lk/lkCommon/messageTemplates";
import {subscription} from "./lk/lkCommon/subscription";
import {newTripRequest} from "./lk/lkCharterer/newTripRequest";
import {searchEmptyLegs} from "./lk/lkCharterer/searchEmptyLegs";
import {requests} from "./lk/lkCharterer/requests";
import {requestsFromClients} from "./lk/lkCharterer/requestsFromClients";
import {fleet} from "./lk/lkFreighter/fleet";
import {requestsFromAgents} from "./lk/lkFreighter/requestsFromAgents";
import {emptyLegs} from "./lk/lkFreighter/emptyLegs";
import {adminRegistrations} from "./lk/lkAdmin/adminRegistrations";
import {adminPlaneApprovals} from "./lk/lkAdmin/adminPlaneApprovals";
import {adminCurrencies} from "./lk/lkAdmin/adminCurrencies";
import {notFound} from "./all/common/notFound";
import {schedule} from "./lk/lkFreighter/schedule";
import {scheduleNew} from "./lk/lkFreighter/scheduleNew";
import {schedulePrivate} from "./lk/lkFreighter/schedulePrivate";
import {schedulePublic} from "./lk/lkFreighter/schedulePublic";
import {eventCalendar} from "./lk/lkFreighter/eventCalendar";
import {lk} from "./lk/lk";
import {legalDocuments} from "./all/common/legalDocuments";

export const routes: {[key in Route]: RouteDescriptor<key>} = {
  [Route.home]: home,
  [Route.forBrokers]: forBrokers,
  [Route.forOperators]: forOperators,
  [Route.notFound]: notFound,

  // Роуты гостя
  [Route.price]: price,
  [Route.agents]: agents,
  [Route.legalDocuments]: legalDocuments,
  [Route.airportData]: airportData,

  // Роуты авторизации и входа
  [Route.login]: login,
  [Route.register]: register,
  [Route.setNewPassword]: setNewPassword,

  [Route.lk]: lk,

  // Общие роуты фрахтователя и фрахтовщика
  [Route.profile]: profile,
  [Route.settings]: settings,
  [Route.messageTemplates]: messageTemplates,
  [Route.subscription]: subscription,

  // Роуты фрахтователя
  [Route.newTripRequest]: newTripRequest,
  [Route.searchEmptyLegs]: searchEmptyLegs,
  [Route.requests]: requests,
  [Route.requestsFromClients]: requestsFromClients,

  // Роуты фрахтовщика
  [Route.requestsFromAgents]: requestsFromAgents,
  [Route.emptyLegs]: emptyLegs,
  // [Route.tripBoard]: tripBoard,
  [Route.schedule]: schedule,
  [Route.scheduleNew]: scheduleNew,
  [Route.schedulePrivate]: schedulePrivate,
  [Route.schedulePublic]: schedulePublic,
  [Route.eventCalendar]: eventCalendar,
  [Route.fleet]: fleet,

  // Роуты администратора сайта
  [Route.adminRegistrations]: adminRegistrations,
  [Route.adminPlaneApprovals]: adminPlaneApprovals,
  [Route.adminCurrencies]: adminCurrencies,
}